import { profile, edit_profile } from "@/module/Profile/locale/profile.th.js";
import { QRCode } from "@/module/ScanQRCode/locale/qrcode.th.js";
import { registerTh, survey } from '@/module/Register/locale/RegisterTh.js';
import { staticTh } from '@/module/Static/locale/StaticTh.js';
import { missionTh } from '@/module/Mission/locale/MissionTh.js';
import { luckydraw } from '@/module/Luckydraw/locale/luckydraw.th'
import { announce } from '@/module/Announcement/locale/announce.th'
export const th = {
    default: {
        search: 'ค้นหา',
        confirm: 'ยืนยัน',
        ok: 'ตกลง',
        cancel: 'ยกเลิก',
    },
    qrcode: QRCode,
    profile,
    edit_profile,
    register: registerTh,
    survey: survey,
    static: staticTh,
    mission: missionTh,
    luckydraw: luckydraw,

    announce: announce,
    date: {
        days: 'วัน',
        months: 'เดือน',
        years: 'ปี',
        minutes: 'นาที',
        minutes_short: 'น.',
        hours: 'ชั่วโมง',
        hours_short: 'ช.ม.',
        date_flase: 'กรุณาระบุวันเกิด',
        month_full: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        month_short: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
        month_full_arr: [{ strvalue: "01", strtext: 'มกราคม' },
        { strvalue: '02', strtext: 'กุมภาพันธ์' },
        { strvalue: '03', strtext: 'มีนาคม' },
        { strvalue: '04', strtext: 'เมษายน' },
        { strvalue: '05', strtext: 'พฤษภาคม' },
        { strvalue: '06', strtext: 'มิถุนายน' },
        { strvalue: '07', strtext: 'กรกฎาคม' },
        { strvalue: '08', strtext: 'สิงหาคม' },
        { strvalue: '09', strtext: 'กันยายน' },
        { strvalue: '10', strtext: 'ตุลาคม' },
        { strvalue: '11', strtext: 'พฤศจิกายน' },
        { strvalue: '12', strtext: 'ธันวาคม' }]
    },
    confirm_redeem: {
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",

        headline: 'ยืนยันการแลกสิทธิ์',
        draw_headline: 'ยืนยันการลุ้นรางวัล',
        surveydraw_headline: 'ยืนยันการร่วมกิจกรรม',
        donate_headline: 'ยืนยันการลุ้นรางวัล',
        default: 'คุณยืนยันที่จะใช้พอยท์',
        default_question: 'ในการแลกสิทธิพิเศษใช่หรือไม่?',
        default_question_donate: 'ในการลุ้นรางวัลใช่หรือไม่?',
        default_survey: 'คุณจะได้รับพอยท์',
        default_survey_question: 'หลังจากตอบแบบสอบถามสำเร็จแล้ว',
        default_survey_approve_question: 'จากการรีวิวผลิตภัณฑ์',
        default_have_time: 'กรุณาใช้ภายใน {0}',
        delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        free_no_timer: 'ยืนยันการรับสิทธิ์',
        free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
        draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        deal_no_timer: 'ยืนยันการรับสิทธิ์',
        deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        buy: 'ยืนยันการซื้อ',
        buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        interface: 'ยืนยันเพื่อเข้าสู่เว็บไซต์ที่ร่วมรายการ',
    },
    redeem_button: {
        default: 'แลกรับสิทธิ์',
        none: '',
        soldOut: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        soldOutBuy: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        maxPerPerson: 'ขออภัย คุณได้แลกรับสิทธิ์นี้แล้ว',
        redeemCoolDown: 'ขออภัย คุณได้รับ Campaign นี้ไปแล้ว กรุณารอกดรับใหม่อีกครั้งภายหลัง',
        nextDate: 'รับสิทธิ์ครั้งต่อไปได้<br/>ตั้งแต่ : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'คุณต้องทำตามเงื่อนไขที่ระบุไว้ใน Campaign นี้ก่อนจึงสามารถกดรับได้ กรุณาอ่านเพิ่มเติมในรายละเอียด',
        campaignExpired: 'สินค้านี้หมดอายุแล้ว',
        campaignExpiredBuy: 'สินค้านี้หมดอายุแล้ว',
        campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
        notEnoughPoint: 'คะแนนไม่พอแลกรับสิทธิ์',
        notSupport: 'ไม่รองรับแคมเปญประเภทนี้',
        review_product: 'รีวิวผลิตภัณฑ์',
        survey: 'ทำแบบสอบถาม',
        donate: 'ลุ้นรางวัล',
        not_enough_points: 'คะแนนไม่พอลุ้นรางวัล',
    },
    purchase: {
        show_code: 'ดูรหัส',
        code_expired: 'รหัสหมดอายุ',

        delivery: 'กำลังดำเนินการจัดส่ง',
        shipped: 'จัดส่งเรียบร้อยแล้ว',
        parcel_no: 'พัสดุเลขที่',

        privilege_shipped: 'จัดส่งเรียบร้อยแล้ว',
        privilege_delivery: 'อยู่ระหว่างจัดส่ง',
        privilege_prepare: 'กำลังเตรียมสินค้า',

        not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
        not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',
        draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',
        draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีได้รับของรางวัลนี้',
        draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',

        text_expired: 'หมดอายุ : ',
        unit_price: 'บาท',
    },
    serial: {
        close_btn: 'ปิด',
        default_privilege_message: 'ตามดีไซน์',
        show_code_at_shop: 'กรุณาแสดงรหัสนี้ ให้แก่ร้านค้า',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',

        draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล หลังจากวันที่ {0}',
        draw_after: 'หลังจากวันที่',

        qr_code: 'คิวอาร์โค้ด',
        barcode: 'บาร์โค้ด',
        code: 'โค้ด',

        copy_code: 'คัดลอก',

        expire_in: 'หมดอายุ ',
        code_expired: 'รหัสหมดอายุ',

        redeem_on: 'แลกรับเมื่อ {0}'
    },
    shipping: {
        headline: 'กรอกที่อยู่จัดส่ง',

        firstname: {
            name: 'ชื่อ',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'ที่อยู่',
            placeholder: 'กรุณากรอกที่อยู่',
            required: 'กรุณากรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            label: 'เบอร์โทรศัพท์',
            placeholder: 'เบอร์โทรศัพท์',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
            invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        },
        nationalid: {
            name: 'เลขประจำตัวประชาชน',
            placeholder: 'เลขประจำตัวประชาชน',
            required: 'กรุณากรอกเลขประจำตัวประชาชน',
            too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
            invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: 'กรุณากรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'แขวง/ตำบล',
            placeholder: 'กรุณาเลือกแขวง/ตำบล',
            required: 'กรุณาเลือกแขวง/ตำบล',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'เขต/อำเภอ',
            placeholder: 'กรุณาเลือกเขต/อำเภอ',
            required: 'กรุณาเลือกเขต/อำเภอ',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'กรุณาเลือกจังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },

        save_address: 'บันทึกที่อยู่ในการจัดส่ง',
        save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

        confirm_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',

        alert_headline: 'ที่อยู่จัดส่ง',
        alert_ok_btn: 'ตกลง',

        modal_success: {
            title: 'คุณได้ทำการรับสิทธิ์เรียบร้อย',
            text_delivery: 'สินค้าจะจัดส่งให้คุณภายใน 15 วันทำการ',
            btn_view: 'ดูสิทธิพิเศษอื่นๆ',
        },

        draw_modal_success: {
            title: 'ขอบคุณที่ร่วมกิจกรรม',
            text: 'คุณสามารถตรวจสอบ<br/>การประกาศผลได้ที่หน้าประกาศผล',
            date: 'ในวันที่ 15 ก.ค. 65',
            btn_view: 'ลุ้นรางวัลอื่นๆ',
        }
    },
    confirm_delivery_address: {
        title: 'ยืนยันที่อยู่ในการจัดส่ง',
        sub_title: 'ที่อยู่ในการจัดส่งพัสดของคุณคือ..',
        change_address: 'เปลี่ยนที่อยู่ในการจัดส่ง',
    },
    main: {
        home_page: "หน้าแรก",
        login: "เข้าสู่ระบบ",
        campaign: "แคมเปญ",
        category: 'หมวดหมู่',
        map: "แผนที่",
        terms: "Terms And Conditions",
        history: 'ประวัติรับสิทธิ์',
        profile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        lang: "ภาษา",
        msgLogout: "ต้องการออกจากระบบ",
        cancel: "ยกเลิก",
        text_expire_point: 'มี {0} พอยท์จะหมดอายุวันที่ {1}',
    },
    campaign: {
        text_privilege: 'สิทธิพิเศษสำหรับคุณ',
        text_all: 'ดูทั้งหมด',
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
        unit_price: 'บาท',
        free: 'ฟรี',
        use: 'ใช้',
        get: 'ได้',
        see_detail: "ดูรายละเอียด",
        add_to_cart: "เพิ่มลงตะกร้า",
    },
    detail: {
        topbar_point_lbl: 'คุณมีพอยท์',
        detail: 'รายละเอียด',
        condition: 'เงื่อนไขการใช้งาน',

        point_unit: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
        available_date: 'แลกได้วันที่',
        expire_date: 'วันหมดอายุ : {0}',

        color: {
            name: 'สี',
            placeholder: 'กรุณาเลือกสี',
            required: 'กรุณาเลือกสี',
        },
        size: {
            name: 'ขนาด',
            placeholder: 'กรุณาเลือกขนาด',
            required: 'กรุณาเลือกขนาด',
        },
    },
    history: {
        page_title_earn: 'ประวัติการสะสมพอยท์',
        page_title_burn: 'ประวัติการแลกพอยท์',

        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้ : ',

        parcel_number: 'เลขพัสดุ : ',
        month_year_form: {
            month: {
                name: '',
                defaultText: 'เดือน',
                required: ''
            },
            year: {
                name: '',
                defaultText: 'ปี',
                required: ''
            }
        },

        text_migrate_earn: 'โอน Points จากระบบเก่า',
    },
    login: {
        text_title: 'เข้าสู่ระบบ',
        contactnumber: {
            label: 'เบอร์โทรศัพท์',
            placeholder: 'กรอกเบอร์โทรศัพท์',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
            invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        },
        confirm_btn: 'ยืนยัน',
        text_skip: 'ข้าม'
    },
    verify_birthday: {
        title: 'เชื่อมต่อบัญชีผู้ใช้งาน',
        msg: 'กรุณากรอกวัน เดือน ปี เกิดของคุณเพื่อยืนยันตัวตน',
        birthdate: {
            name: 'วันเกิด',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: 'รูปแบบวันเกิดไม่ถูกต้อง',
            date: {
                name: '',
                defaultText: 'วัน',
                required: ''
            },
            month: {
                name: '',
                defaultText: 'เดือน',
                required: ''
            },
            year: {
                name: '',
                defaultText: 'ปี',
                required: ''
            },
        },
        modal_error: {
            title: 'ขออภัยไม่สามารถดำเนินการได้',
            error: 'Error code :',
            msg: 'กรุณาติดต่อ Admin ',
            line: 'https://page.line.me/?accountId=ovi0424j',
            btn_ok: 'Line: @Bioderma Thailand',
            btn_cancel: 'ปิด'
        }
    },
    otp:{
        title_otp: "ยืนยัน OTP",
        text_send_otp: "เราจะส่งรหัส OTP ไปยังหมายเลข ",
        text_enter_otp: "กรุณากรอกรหัส OTP",
        otp_timeout: "รหัส OTP จะหมดอายุภายใน",
        minute: "นาที",
        text_otp_expired: "รหัส OTP หมดอายุ",
        resend_otp: "ส่งอีกครั้ง",

        refcode: "Ref code : ",
        otpLength: "Please enter OTP Correctly",
        requireInput: "Please enter OTP Correctly",

        expiredOtp: "OTP has been expired, please request OTP once.",
        newOtp: "OTP has been sent successfully. ",
        failedOtp: "Failed to send OTP, Please try again later.",
        notCorrectOtp: "OTP is not correct, please try again.",
        otpAlertheadline: 'แจ้งเตือน',
        otpInvalid: "กรุณากรอก OTP ให้ถูกต้อง",

        btn_confirm: 'ยืนยัน',
    },
    modalProductList: {
        buyFrom: {
            name: 'ซื้อสินค้าจาก',
            placeholder: 'เลือกร้านค้า',
            required: 'กรุณาเลือกร้านค้า',
            too_short: '',
            invalid: '',
            defaultText: 'เลือกร้านค้า',
        otpInvalid: "กรุณากรอก OTP ให้ถูกต้อง",

        btn_confirm: 'ยืนยัน',
        },
        shopEarn: {
            name: '',
            placeholder: 'กรุณากรอกชื่อร้าน',
            required: 'กรุณากรอกชื่อร้าน',
            too_short: '',
            invalid: '',
        },
    },
    modalSkip: {
        collect_points: {
            title: 'การสะสมพอยท์',
            msg: 'หากคุณต้องการสะสมพอยท์<br/>กรุณาเข้าสู่ระบบ'
        },
        mission: {
            title: 'ภารกิจ',
            msg: 'หากคุณต้องการทำภารกิจ<br/>กรุณาเข้าสู่ระบบ'
        },
        redeem: {
            title: 'แลกรับสิทธิ์',
            msg: 'คุณต้องเข้าสู่ระบบก่อนแลกรับสิทธิ์'
        },
        btn_confirm: 'เข้าสู่ระบบ',
        btn_cancel: 'ยกเลิก'
    },
    topbar: {
        text_all_point: 'คุณมีพอยท์ทั้งหมด',
        text_expire_point: 'มี {0} พอยท์<br>จะหมดอายุวันที่ {1}',
        text_login: 'กรุณาเข้าสู่ระบบก่อนใช้งาน',
        text_btn_login: 'เข้าสู่ระบบ',
    },
    reward: {
        page_title: 'สิทธิพิเศษ',
    },
    pointGuide: {
        title: 'พอยท์แต่ละสินค้า',
    },
    text_nodata: 'ไม่พบข้อมูล',
    draw: {
        page_title: 'ลุ้นรางวัล'
    },
    modal_consent_age: {
        title: 'กรุณายืนยันอายุใหม่',
        msg: 'เนื่องจากการใช้งานแอปพลิเคชัน<br/>ต้องมีอายุมากกว่า 20 ปีบริบูรณ์',
        msg_detail: 'ฉันมีอายุ 20 ปีบริบูรณ์แล้ว',
        btn: 'ยืนยัน'
    }
};
